module.exports = __webpack_public_path__ + "images/h5-bottom-dark.c01afbfb.png";